import { SaveButton } from "components/Buttons"
import {
  CheckboxField,
  CountryCode,
  InputError,
  TagsMultiSelect,
  TextField,
} from "components/RenderInput"
import { MULTIPLE_USER } from "constants/form_names"
import React, { useEffect } from "react"
import { connect } from "react-redux"
import { Button, Col, Row } from "reactstrap"
import { change, Field, FieldArray, reduxForm } from "redux-form"
import asyncValidate from "./multipleUserFormAsyncValidation"
import validate from "./multipleUserFormValidation"
import { shouldDisplaySSN } from "./utils"

const renderUsers = ({ fields, meta: { error, submitFailed }, displaySSN }) => {
  return (
    <>
      <Row>
        <Col>{submitFailed && error && <InputError error={error} />}</Col>
      </Row>
      {fields?.map((user, index) => (
        <React.Fragment key={index + 1}>
          <Row>
            <Col className="p-2">
              <label>
                First name<span className="text-danger">*</span>
              </label>
              <Field
                name={`${user}.firstName`}
                type="text"
                component={TextField}
                placeholder="First name"
              />
            </Col>

            <Col className="p-2">
              <label>
                Last name<span className="text-danger">*</span>
              </label>
              <Field
                name={`${user}.lastName`}
                type="text"
                component={TextField}
                placeholder="Last name"
              />
            </Col>

            <Col className="p-2">
              <label>
                Email Address<span className="text-danger">*</span>
              </label>
              <Field
                name={`${user}.email`}
                type="text"
                component={TextField}
                placeholder="Email address"
              />
            </Col>
          </Row>

          <Row>
            <Col className="d-none d-lg-block p-2">
              <label>
                Display Name<span className="text-danger">*</span>
              </label>
              <Field
                name={`${user}.display_name`}
                type="text"
                component={TextField}
                placeholder="Display Name"
              />
            </Col>
            <Col className="p-2" xs="auto">
              <label>Country Code</label>
              <Field
                name={`${user}.country_code`}
                // label={"Country Code"}
                component={CountryCode}
                maxWidth="110px"
                disabled={true}
                editable={false}
                country="us"
              />
            </Col>

            <Col className="p-2">
              <label>Phone number</label>
              <Field
                name={`${user}.phone`}
                type="text"
                component={TextField}
                placeholder="Phone number"
              />
            </Col>

            {displaySSN && (
              <Col className="p-2">
                <label>Last 4 SSN</label>
                <Field
                  name={`${user}.last_4_ssn`}
                  type="text"
                  component={TextField}
                  placeholder="Last 4 SSN"
                />
              </Col>
            )}
          </Row>
          <Row>
            <Col className="p-2" xs={"auto"}>
              <Button
                outline
                color="danger"
                onClick={() => fields.remove(index + 1)}
              >
                Delete
              </Button>
            </Col>
          </Row>
          <Row className="py-2">
            <hr className="full-width" />
          </Row>
        </React.Fragment>
      ))}
    </>
  )
}

let MultipleUserForm = ({
  handleSubmit,
  metaTags,
  onTagCreate,
  loading,
  initFormWithUsers,
  vendorId,
  users,
}) => {
  useEffect(() => {
    initFormWithUsers(users)
  }, [users])

  return (
    <form onSubmit={handleSubmit}>
      <Row className="form-group">
        <Col className="p-2">
          <Field
            name={"tags"}
            label={"Tags"}
            component={TagsMultiSelect}
            create={onTagCreate}
            options={metaTags?.map(({ id, tag }) => ({
              value: id,
              label: tag,
            }))}
          />
        </Col>
      </Row>
      <Row className="form-group">
        <FieldArray
          name="users"
          component={renderUsers}
          displaySSN={shouldDisplaySSN(vendorId)}
        />
      </Row>
      <Row className="form-group">
        <Col className="py-3">
          <Field
            name={"sendInvite"}
            label={"Send invite"}
            component={CheckboxField}
          />
        </Col>
      </Row>
      <Row className="form-group">
        <Col>
          <SaveButton content="Save" loading={loading} />
        </Col>
      </Row>
    </form>
  )
}

MultipleUserForm = reduxForm({
  form: MULTIPLE_USER,
  validate,
  asyncValidate,
  asyncBlurFields: ["users[].email"],
  asyncChangeFields: ["users[].email"],
})(MultipleUserForm)

const mapDispatchToProps = (dispatch, props) => ({
  initFormWithUsers: values => dispatch(change(MULTIPLE_USER, "users", values)),
})
export default connect(null, mapDispatchToProps)(MultipleUserForm)
